/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Anchor_ReplaceInputs */

const en_us2_body_assessment_anchor_replace = /** @type {(inputs: Body_Assessment_Anchor_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entering a new reference measurement on a later assessment replaces this one. There is no other way to edit it.`)
};

const pt_br2_body_assessment_anchor_replace = /** @type {(inputs: Body_Assessment_Anchor_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informar uma nova medição de referência numa próxima avaliação substitui esta. Não há outro jeito de editá-la.`)
};

const es_419_body_assessment_anchor_replace = /** @type {(inputs: Body_Assessment_Anchor_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresar una nueva medición de referencia en una evaluación posterior reemplaza esta. No hay otra forma de editarla.`)
};

const pt_pt2_body_assessment_anchor_replace = /** @type {(inputs: Body_Assessment_Anchor_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicar uma nova medição de referência numa próxima avaliação substitui esta. Não há outra forma de a editar.`)
};

const fr_fr2_body_assessment_anchor_replace = /** @type {(inputs: Body_Assessment_Anchor_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisir une nouvelle mesure de référence lors d'une prochaine évaluation remplace celle-ci. Il n'y a pas d'autre moyen de la modifier.`)
};

const de_de2_body_assessment_anchor_replace = /** @type {(inputs: Body_Assessment_Anchor_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine neue Referenzmessung bei einer späteren Messung ersetzt diese. Anders lässt sie sich nicht bearbeiten.`)
};

const it_it2_body_assessment_anchor_replace = /** @type {(inputs: Body_Assessment_Anchor_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserire una nuova misurazione di riferimento in una valutazione successiva sostituisce questa. Non c'è altro modo per modificarla.`)
};

/**
* | output |
* | --- |
* | "Entering a new reference measurement on a later assessment replaces this one. There is no other way to edit it." |
*
* @param {Body_Assessment_Anchor_ReplaceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_anchor_replace = /** @type {((inputs?: Body_Assessment_Anchor_ReplaceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Anchor_ReplaceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_anchor_replace(inputs)
	if (locale === "es-419") return es_419_body_assessment_anchor_replace(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_anchor_replace(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_anchor_replace(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_anchor_replace(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_anchor_replace(inputs)
	return en_us2_body_assessment_anchor_replace(inputs)
});
export { body_assessment_anchor_replace as "body-assessment.anchor_replace" }